<template>
  <div class="user-transfer">
    <div class="title">
      Chuyển Tiền Điện Tử {{ getInfo ? getInfo.Currency_Name : "" }}
    </div>
    <b-form @submit.prevent="onTransfer()">
      <div class="form-group">
        <label for="ToAccount">Mã Định Danh Người Nhận (ID)</label>
        <b-form-input
          v-model.trim="transfer.userID_receive"
          required
          type="text"
          id="ToAccount"
          placeholder="Nhập Mã Định Danh Người Nhận (ID)"
        ></b-form-input>
      </div>
      <div class="form-group">
        <label for="Balance">Số Dư {{ CoinID == 10 ? "VND" : "USD" }}</label>
        <b-form-input
          v-model.trim="Balance[CoinID == 10 ? 'VND' : 'USD']"
          required
          type="number"
          id="Balance"
          readonly
        ></b-form-input>
      </div>
      <div class="form-group">
        <label for="Amount">Số Tiền</label>
        <b-form-input
          v-model.trim="transfer.amount"
          required
          type="number"
          id="Amount"
          placeholder="Nhập số tiền là số tự nhiên"
        ></b-form-input>
      </div>
      <div class="form-group">
        <label for="authCode">Mã Bảo Mật 2 Lớp</label>
        <b-form-input
          v-model.trim="transfer.authCode"
          required
          type="text"
          id="authCode"
          placeholder="Nhập mã bảo mật 2 lớp"
        ></b-form-input>
      </div>
      <div
        class="form-group my-4 d-flex justify-content-center align-items-center"
      >
        <b-button variant="danger" class="mx-2" @click="closePopup()">
          Huỷ
        </b-button>
        <b-button variant="primary" class="mx-2" type="submit">
          Chuyển Tiền
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filter from "lodash/filter";

export default {
  props: {
    CoinID: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      transfer: {
        userID_receive: "",
        amount: "",
        authCode: "",
        token: null,
        coin: null,
      },
      balance: 0,
    };
  },
  computed: {
    ...mapGetters({
      Coin: "wallet/Coin",
      Balance: "wallet/Balance",
    }),
    getInfo() {
      return filter(this.Coin, (elm) => elm.Currency_ID === this.CoinID)[0];
    },
  },
  methods: {
    async onTransfer() {
      const token = await this.genarateCaptChaV3("wallet");
      if (!token) {
        this.$toastr.e("Too Fast! Please Wating Recaptcha.", "Withdraw Failed");
      }
      this.transfer.token = token;
      this.$store.dispatch("wallet/req_postTransfer", this.transfer);
    },
    closePopup() {
      this.$emit("closePopup", true);
    },
  },
  mounted() {
    this.transfer.coin = this.CoinID;
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      // eslint-disable-next-line default-case
      switch (mutation.type) {
        case "wallet/TRANSFER_SUCCESS":
          this.transfer = {
            userID_receive: "",
            amount: "",
            authCode: "",
            token: null,
            coin: null,
          };
          break;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style lang="scss">
.user-transfer {
  max-width: 405px;
  margin: auto;
  width: 100%;
  min-width: 300px;
  @media (min-width: 768px) {
    min-width: 576px;
    max-width: 600px;
  }
  .title {
    font-weight: 600;
    font-size: clamp(16px, 2vw, 18px);
    color: #ffff;
    text-align: center;
    padding: 15px 25px;
    box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.28);
    background: linear-gradient(to bottom, #008cff, #003395);
    margin-bottom: 25px;
  }
  .form-group {
    margin-bottom: 15px;
    padding: 0px 25px;
    label {
      font-weight: 600;
      color: #fff;
      font-size: 16px;
      margin-bottom: 5px;
    }
    select,
    input {
      border: 0;
      border-radius: 0;
      border-bottom: 2px solid #6c757d;
      background-color: #00000057;
      border-radius: 5px 5px 0 0;
      height: 40px;
      font-size: clamp(15px, 1vw, 16.2px);
      font-weight: 600;
      &:focus {
        box-shadow: none;
        border-bottom: 2px solid #097501;
      }
      &::placeholder {
        font-weight: 500;
        font-size: clamp(13px, 1vw, 15px);
      }
    }
  }
}
</style>
